import axios from "axios";

const BASE_URL = process.env.REACT_APP_NODEJS_SERVER_URL;

function authConfig(extra = {}) {
  return {
    headers: {
      accessToken: localStorage.getItem("accessToken"),
    },
    ...extra,
  };
}

export async function getGooglePlacesSettings(instanceUniqueId) {
  const response = await axios.get(
    `${BASE_URL}/instances/${instanceUniqueId}/google-places-settings`,
    authConfig(),
  );
  return response.data;
}

export async function saveGooglePlacesSettings(instanceUniqueId, payload = {}) {
  const response = await axios.put(
    `${BASE_URL}/instances/${instanceUniqueId}/google-places-settings`,
    payload,
    authConfig(),
  );
  return response.data;
}

export async function getGooglePlacesBrowserConfig(instanceId) {
  const response = await axios.get(
    `${BASE_URL}/instances/${instanceId}/google-places-browser-config`,
    authConfig(),
  );
  return response.data;
}

export function isGooglePlacesAvailable(config = {}) {
  return config?.googlePlaces?.enabled === true && !!config?.googlePlaces?.apiKey;
}
